import * as React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import SectionLayout from '../components/section-layout'

const HuntingPage = () => {
  const data = useStaticQuery(graphql`
    query {
      allMdx(filter: { frontmatter: { tags: { eq: "hunting" } } }) {
        edges {
          node {
            frontmatter {
              title
              slug
              featuredImage {
                childImageSharp {
                  fluid(maxWidth: 800) {
                    src
                  }
                }
              }
            }
          }
        }
      }
      hero: file(relativePath: { eq: "hunting-page-elk.jpg" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
    }
  `)

  return <SectionLayout pageTitle="Hunting" data={data} />
}

export default HuntingPage
